import { AssessmentValue } from './assessment.value';

export class AssessmentValueDto {
    name: string;
    description: string;
    showToAssessor: boolean;

    constructor(data: AssessmentValue) {
        this.name = data.name;
        this.description = data.description;
        this.showToAssessor = data.showToAssessor;
    }
}
